<template>
  <div class="why">
    <div class="page-wit">
      <div class="title">
        <h2>
          <span class="tit-l">
            <img src="@/assets/images/partner/tit-l.png" width="34" />
          </span>为什么要当城市代理商
          <span class="tit-r">
            <img src="@/assets/images/partner/tit-r.png" width="35" />
          </span>
        </h2>
      </div>
      <dl>
        <dt>
          <img src="@/assets/images/partner/support-1.png" width="144" />
        </dt>
        <dd class="name">行业前景好</dd>
        <dd class="info">全国近1000万家餐厅需要全场无忧的采购新鲜餐饮原材料，生鲜行业未来二十年乃至更久都会是朝阳产业。</dd>
      </dl>
      <dl>
        <dt>
          <img src="@/assets/images/partner/support-2.png" width="144" />
        </dt>
        <dd class="name">市场红利大</dd>
        <dd class="info">
          三四线城市的生鲜电商
          <br />刚刚启动。
        </dd>
      </dl>
      <dl>
        <dt>
          <img src="@/assets/images/partner/support-3.png" width="144" />
        </dt>
        <dd class="name">开城支持多</dd>
        <dd class="info">从运营、培训到技术全方位支持。</dd>
      </dl>
      <dl class="none">
        <dt>
          <img src="@/assets/images/partner/support-4.png" width="144" />
        </dt>
        <dd class="name">平台规模大</dd>
        <dd class="info">可以借助美菜平台规模效应带来的增值收益、延伸收益。</dd>
      </dl>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
// import partnerForm from "./partnerForm";
export default {
  name: "support",
  // components: {
  //   partnerForm,
  // },
  data() {
    return {
      dialogVisbility: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.why {
  background: #fff;
  padding: 75px 0;
  .title {
    height: 100px;
    h2 {
      font-size: 34px;
      position: relative;
      width: 440px;
      margin: 0 auto;
      text-align: center;
    }
  }
  dl {
    width: 220px;
    float: left;
    margin-right: 40px;
    text-align: center;
    dd.name {
      margin-top: 40px;
      font-size: 24px;
    }
    dd.info {
      text-align: left;
      font-size: 15px;
      color: #757575;
      line-height: 1.8;
      margin-top: 15px;
      text-align: center;
    }
  }
  dl.none {
    margin-right: 0;
  }
}
</style>
